import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { components, OptionProps } from 'react-select';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../../../i18n/constants/keys';
import AsyncCustomSelect from '../../../../../../../ui/custom_react_select/async_select';
import { IBankQuestionOption } from '../interfaces';

interface BankImportSectionProps {
  onQuestionChange: (selectedOption: IBankQuestionOption) => void;
  loadOptions: (
    inputValue: string,
    callback: (options: IBankQuestionOption[]) => void,
  ) => void;
}

const BankOptionRenderer = (props: OptionProps<IBankQuestionOption, false>) => {
  return (
    <components.Option {...props}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: 'text.primary',
            fontSize: '0.8rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            mr: 2,
          }}
        >
          {props.data.label}
        </Typography>
        <Box
          component="span"
          sx={{
            fontSize: '0.65rem',
            fontWeight: 700,
            color: 'primary.main',
            bgcolor: 'primary.50',
            px: 1,
            py: 0.25,
            borderRadius: '4px',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            flexShrink: 0,
          }}
        >
          {props.data.typeLabel}
        </Box>
      </Box>
    </components.Option>
  );
};

export const BankImportSection = ({
  onQuestionChange,
  loadOptions,
}: BankImportSectionProps) => {
  const { t } = useTranslation(NS.adminPages);

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: '12px',
        bgcolor: 'rgba(99, 102, 241, 0.03)',
        border: '1px solid',
        borderColor: 'rgba(99, 102, 241, 0.15)',
      }}
    >
      <AsyncCustomSelect
        name="preScreenQuestion"
        value={[]}
        placeholder={t(
          ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.searchPlaceholder,
        )}
        defaultOptions={true}
        onChange={(option: unknown) => {
          if (option) {
            onQuestionChange(option as IBankQuestionOption);
          }
        }}
        loadOptions={loadOptions}
        label={t(
          ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.importFromBank,
        )}
        components={{ Option: BankOptionRenderer }}
      />
    </Box>
  );
};
